import script from "./MultiStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./MultiStylePanel.vue?vue&type=style&index=0&id=de815ffa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de815ffa"]])

export default __exports__